import {
  Slider as MUISlider,
  SliderProps as MUISliderProps,
} from "@mui/material";

import { Controller } from "react-hook-form";

type SliderProps = {
  name: string;
  control: any;
  required?: boolean;
} & MUISliderProps;

const Slider = ({
  name,
  control,
  required = false,
  defaultValue,
  ...props
}: SliderProps) => {
  
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required }}
      render={({ field: { onChange, value } }) => (
        <MUISlider
          value={value}
          onChange={onChange}
          {...props}
        />
      )}
    />
  );
};

export default Slider;
